import React from 'react'
import { Field } from 'redux-form';
import { Item, painel, fieldset } from 'scorpion-core';


import Comentarios from './Comentarios';


function componentRelEspelho(comp, dados) {


    return fieldset(comp.label, painel("nao implementadao", { widths: ['*'] }))

}

// handleChange = name => event => {
//     this.setState({ [name]: event.target.checked });
//   };

function component(item) {
    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} label={item.label} component={Comentarios} />
    </Item>)
}

const modelo = { field: "comentarios", label: "Comentarios", typeComponente: "Comentarios" }

const comp = {
    typeComponente: "Comentarios",
    configView: {
        nome: "Comentários",
        modelo

    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Comentarios/ComentarioComp.js